export default "__VITE_ASSET__8d15942b__"